module.exports = __webpack_public_path__ + "static/media/topo-bench-icra26.41afd84a.png";